import React from "react";
import "./HouseingTransform.css";

const DeepCleaningSTransform = () => {
  return (
    <section className="workplace-cta-section">
      <div className="workplace-cta-container">
        <h2 className="workplace-cta-title">
          Ready for a Deep Clean Transformation?
        </h2>

        <p className="workplace-cta-text">
          Schedule a comprehensive deep cleaning service and experience the
          difference in your facility&apos;s hygiene and appearance
        </p>

        <a
          href="https://wa.me/919899811123?text=Deep%20Cleaning%20Services"
          target="_blank"
          rel="noopener noreferrer"
          className="workplace-cta-btn"
        >
          Schedule a Deep Cleaning →
        </a>
      </div>
    </section>
  );
};

export default DeepCleaningSTransform;
